// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import { LoadableLazy } from '@confluence/loadable';

export type { ContextualInviteNudgeFlagBaseProps } from './ContextualInviteNudgeFlag.tsx';
export { LIVE_PAGE_SOURCE } from './ContextualInviteNudgeFlag.tsx';

export const ContextualInviteNudgeFlagLoadable = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ContextualInviteNudgeFlag" */ './ContextualInviteNudgeFlag.tsx'
			)
		).ContextualInviteNudgeFlag,
});
